import { CORPORATE, CORPORATESEARCH } from "./type";
import { API_URL } from "../config";
import axios from "axios";

const corporateFn = (data) => {
    return {
        type: CORPORATE,
        payload: data
    };
}

export const corporateApi = (type) => {
    let data = {};
    const title = type === 1 ? 'CorporateGovernancePrelist' : 'CorporateGovernancePostlist';
    return (dispatch) => {
        axios.post(API_URL + title, data).then((response) => {
            if (response.data && response.data.status === 200) {
                if (response.data.corp_cat) {
                    try {
                        let categories = JSON.parse(response.data.corp_cat);
                        if (Array.isArray(categories)) {
                            // Sort categories and move Board of Directors (assumed to be ID 8) to first position
                            categories.sort((a, b) => {
                                if (a.id === 8) return -1;
                                if (b.id === 8) return 1;
                                return a.id - b.id;
                            });
                            response.data.corp_cat = JSON.stringify(categories);
                        }
                    } catch (e) {
                        console.error("Error sorting categories:", e);
                    }
                }
                if (response.data.corp_year) {
                    try {
                        let years = JSON.parse(response.data.corp_year);
                        if (Array.isArray(years)) {
                            // Sort years descending
                            years.sort((a, b) => parseInt(b.year) - parseInt(a.year));
                            response.data.corp_year = JSON.stringify(years);
                        }
                    } catch (e) {
                        console.error("Error sorting years:", e);
                    }
                }
            }
            dispatch(corporateFn(response));
        });
    };
}

const corporatesearchFn = (data) => {
    const dt = { ...data, IsSuccess: 1 };
    return {
        type: CORPORATESEARCH,
        payload: dt
    };
}

export const corporatesearchApi = (cid, yid, mid, pid, listType) => {
    let data = {
        category_id: cid,
        year_id: yid,
        meeting_id: mid,
        policies_id: pid,
        list_type: listType
    };
    return (dispatch) => {
        axios.post(API_URL + 'CorporateGovernanceSearch', data).then((response) => {
            if (response.data && response.data.corp_doc) {
                try {
                    let docs = JSON.parse(response.data.corp_doc);
                    if (Array.isArray(docs)) {
                        // Sort documents by ID descending to show recently uploaded at the top
                        // If IDs are the same or missing, use created_at as fallback
                        docs.sort((a, b) => {
                            if (b.id !== a.id) {
                                return (b.id || 0) - (a.id || 0);
                            }
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                        response.data.corp_doc = JSON.stringify(docs);
                    }
                } catch (e) {
                    console.error("Error sorting documents:", e);
                }
            }
            dispatch(corporatesearchFn(response));
        });
    };
}
